import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pencil, Trash2 } from "lucide-react";
import BonusDetailModal from "../../../modals/Hrms/BonusDetailModal";
import ApprovalBonusModal from "../../../modals/Hrms/ApprovalBonusModal";
import { fetchBonuses, deleteBonus } from "../../../redux/bonusSlice";


const BonusDetail = () => {
  const dispatch = useDispatch();
  const { bonuses, status, error } = useSelector((state) => state.bonuses);
  const [isApplyModalOpen, setIsApplyModalOpen] = useState(false);
  const [isApprovalModalOpen, setIsApprovalModalOpen] = useState(false);
  const [editingBonus, setEditingBonus] = useState(null);

  useEffect(() => {
    dispatch(fetchBonuses());
  }, [dispatch]);

  const handleEditBonus = (bonus) => {
    setEditingBonus(bonus);
    setIsApplyModalOpen(true);
  };

  const handleDeleteBonus = (id) => {
    dispatch(deleteBonus(id));
  };

  const handleOpenApprovalModal = (bonus) => {
    setEditingBonus(bonus);
    setIsApprovalModalOpen(true);
  };

  return (
    <div className="container mx-auto p-4 border border-[#241763]">
      <div className="flex justify-between items-center mb-4">
        <h1 className="text-xl font-bold">Session Name: March-2024</h1>
        <button
          onClick={() => setIsApplyModalOpen(true)}
          className="bg-[#241763] text-white px-4 py-2 rounded"
        >
          Apply Bonus
        </button>
      </div>

      {status === "loading" && <p>Loading bonuses...</p>}
      {status === "failed" && <p>Error: {error}</p>}
      {status === "succeeded" && (
        <div className="overflow-x-auto overflow-visible">
          <div className="max-h-[70vh] overflow-x-auto overflow-y-auto">
            <table className="table-auto w-full mt-6 text-sm">
              <thead className="py-4 border-b font-bold">
                <tr>
                  <th>EMP. CODE</th>
                  <th>EMPLOYEE NAME</th>
                  <th>DATE</th>
                  <th>SESSION</th>
                  <th>AMOUNT</th>
                  <th>DESCRIPTION</th>
                  <th>STATUS</th>
                  <th>ACTION</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {bonuses.map((bonus) => (
                  <tr key={bonus.id}>
                    <td>{bonus.employeeId || "SAS-015"}</td>
                    <td>
                      <div>
                        <div className="font-medium">{bonus.employeeName}</div>
                        <div className="text-sm text-gray-500">
                          {bonus.department || "Engineering & Production"}
                        </div>
                      </div>
                    </td>
                    <td>{new Date(bonus.applyDate).toLocaleDateString()}</td>
                    <td>{bonus.sessionName}</td>
                    <td>{bonus.amount}</td>
                    <td>{bonus.description || "-"}</td>
                    <td
                      className="cursor-pointer"
                      onClick={() => handleOpenApprovalModal(bonus)}
                    >
                      <span
                        className={`px-2 py-1 rounded ${
                          bonus.status === "Pending"
                            ? "bg-orange-100 text-orange-600"
                            : "bg-green-100 text-green-600"
                        }`}
                      >
                        {bonus.status}
                      </span>
                    </td>
                    <td className="space-x-2 flex items-center py-2">
                      <button
                        className="bg-[#B6A5C9]/50 text-white p-2 rounded mr-2 hover:bg-[#241763]/60 group"
                        onClick={() => handleEditBonus(bonus)}
                      >
                        <Pencil className="text-[#241763] w-4 h-4 group-hover:text-white" />
                      </button>
                      <button
                        className="bg-[#B6A5C9]/50 text-white p-2 rounded hover:bg-[#241763]/60 group"
                        onClick={() => handleDeleteBonus(bonus.id)}
                      >
                        <Trash2 className="text-[#241763] w-4 h-4 group-hover:text-white" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <BonusDetailModal
        isOpen={isApplyModalOpen}
        onClose={() => {
          setEditingBonus(null);
          setIsApplyModalOpen(false);
        }}
        initialData={editingBonus}
      />
      <ApprovalBonusModal
        isOpen={isApprovalModalOpen}
        onClose={() => setIsApprovalModalOpen(false)}
        bonus={editingBonus}
      />
    </div>
  );
};

export default BonusDetail;